import {connect} from 'react-redux'
import ContentView from '../components/ContentView'

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  view_state: state.view_state,
  loadingContent: state.loadingContent,
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentView)


// WEBPACK FOOTER //
// ./src/layouts/Content/containers/ContentContainer.js